"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var Separator = function Separator(_ref) {
  var text = _ref.text,
      _ref$hr = _ref.hr,
      hr = _ref$hr === void 0 ? false : _ref$hr,
      _ref$noMarginBottom = _ref.noMarginBottom,
      noMarginBottom = _ref$noMarginBottom === void 0 ? false : _ref$noMarginBottom,
      _ref$noMarginTop = _ref.noMarginTop,
      noMarginTop = _ref$noMarginTop === void 0 ? false : _ref$noMarginTop,
      _ref$mediumMargin = _ref.mediumMargin,
      mediumMargin = _ref$mediumMargin === void 0 ? false : _ref$mediumMargin,
      _ref$mediumHeight = _ref.mediumHeight,
      mediumHeight = _ref$mediumHeight === void 0 ? false : _ref$mediumHeight,
      _ref$fullTextLine = _ref.fullTextLine,
      fullTextLine = _ref$fullTextLine === void 0 ? false : _ref$fullTextLine,
      _ref$fullTextLineText = _ref.fullTextLineText,
      fullTextLineText = _ref$fullTextLineText === void 0 ? false : _ref$fullTextLineText;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
    className: "".concat(_styleModule.default.seperator, " ").concat(noMarginBottom ? _styleModule.default.noMarginBottom : '', " ").concat(noMarginTop ? _styleModule.default.noMarginTop : '', " ").concat(mediumMargin ? _styleModule.default.mediumMargin : '', " ").concat(mediumHeight ? _styleModule.default.mediumHeight : ''),
    children: [text && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        className: _styleModule.default.line
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        className: _styleModule.default.text,
        children: text
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        className: _styleModule.default.line
      })]
    }), fullTextLine && /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
        className: _styleModule.default.lineWrapper,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          className: "".concat(_styleModule.default.lineFull, " ").concat(_styleModule.default.line)
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          className: _styleModule.default.text,
          children: fullTextLineText
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          className: "".concat(_styleModule.default.lineFull, " ").concat(_styleModule.default.line)
        })]
      })
    }), hr && /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        className: "".concat(_styleModule.default.line, " ").concat(_styleModule.default.full, " ").concat(mediumMargin ? _styleModule.default.mediumMargin : '')
      })
    })]
  });
};

var _default = Separator;
exports.default = _default;